import { render, staticRenderFns } from "./dangerousAirRoute.vue?vue&type=template&id=619d5d46&scoped=true"
import script from "./dangerousAirRoute.vue?vue&type=script&lang=js"
export * from "./dangerousAirRoute.vue?vue&type=script&lang=js"
import style0 from "./dangerousAirRoute.vue?vue&type=style&index=0&id=619d5d46&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619d5d46",
  null
  
)

export default component.exports